// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'

export default class ProductHunt extends Component {
  render () {
    return (
      <div className='mts'>
        <a rel="noopener noreferrer"
          href='https://www.producthunt.com/posts/murkstom-2?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-murkstom-2'
          target='_blank'
        >
          <img
            src='https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=187305&theme=dark'
            alt='Murkstom - Build 100% native mobile apps with no-code | Product Hunt Embed'
            style={{ width: '220px' }}
          />
        </a>
      </div>
    )
  }
}
